import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CustomModalFooter from 'src/components/custom_components/CustomModal/CustomModalFooter';

import { I18NextNS } from 'src/models/Language.model';

interface GradableFooterProps {
  onCompleteExam: () => void;
}

export default function GradableFooter({
  onCompleteExam,
}: GradableFooterProps) {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModalFooter>
      <Button
        variant="primary"
        data-track="exam.analyzing-modal.complete-exam"
        data-test="analyzing-modal-complete-exam"
        data-observe
        onClick={onCompleteExam}
      >
        {t('newExam.submit')}
      </Button>
    </CustomModalFooter>
  );
}
